// extracted by mini-css-extract-plugin
export var button = "_d1-7";
export var buttonRow = "_d1-6";
export var fadeIn = "_d1-1";
export var gradient = "_d1-0";
export var panel = "_d1-2";
export var panelIn = "_d1-3";
export var subtitle = "_d1-5";
export var title = "_d1-4";